import { IntlProvider } from "react-intl";

// We've dropped fetching any translations while we're not in a territory that needs them.
// Refer to PR #623 if you want to bring them back later and do the following:
// - Rollback webpack changes to load the translations
// - CircleCI config to extract the translations
// - Function to fetch the translations that was deleted in PR #623
// - Changes in this file to fetch the translations

export const TranslationsProvider: FCwC = ({ children }) => {
  return (
    <IntlProvider
      locale={"en"}
      // Don't log errors if we've not fetched any messages as it would be super noisy
      // (we'd log every component in the app falling back to it's default)/
      // If the messages failed to fetch we will have logged that elsewhere
      onError={(err) => {
        const error = { name: "TranslationsProvider", error: err };
        if (!err?.message?.includes("using default message as fallback")) {
          console.error(error);
        }
      }}
    >
      {children}
    </IntlProvider>
  );
};
